import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Trash2, Plus } from "lucide-react";

const blank = { category: "Landing", name: "", amount: "", unit: "", notes: "" };

export default function AdminFees() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(blank);

  const load = () => api.get("/fees").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    await api.post("/fees", form);
    setForm(blank);
    load();
  };
  const del = async (id) => { await api.delete(`/fees/${id}`); load(); };

  return (
    <div data-testid="admin-fees">
      <div className="section-label">Fee Schedule</div>
      <h1 className="font-display font-bold text-3xl text-slate-950 mt-2">Layout & Fees</h1>

      <div className="mt-8 bg-white border border-slate-200 p-6 rounded-md grid sm:grid-cols-2 gap-3">
        <select data-testid="fee-category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="border border-slate-300 px-3 py-2 bg-white">
          <option>Landing</option>
          <option>Ramp</option>
          <option>Hangar</option>
          <option>Tie-Down</option>
          <option>Other</option>
        </select>
        <input data-testid="fee-name" placeholder="Fee name (e.g., Single-Engine Piston)" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <input data-testid="fee-amount" placeholder="Amount (e.g., $25 or Waived w/ fuel)" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <input data-testid="fee-unit" placeholder="Unit (e.g., per landing, per night)" value={form.unit} onChange={(e) => setForm({ ...form, unit: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <input data-testid="fee-notes" placeholder="Notes (optional)" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <button data-testid="fee-add" onClick={add} className="bg-slate-950 text-white px-4 py-2 sm:col-span-2 inline-flex items-center gap-2 justify-center"><Plus className="h-4 w-4" /> Add fee</button>
      </div>

      <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((f) => (
          <div key={f.id} className="bg-white border border-slate-200 p-5 rounded-md">
            <div className="flex items-start justify-between">
              <div>
                <div className="text-xs font-mono uppercase tracking-widest text-sky-600">{f.category}</div>
                <div className="font-display text-lg font-semibold mt-1">{f.name}</div>
              </div>
              <button data-testid={`fee-del-${f.id}`} onClick={() => del(f.id)} className="text-red-600 hover:text-red-800"><Trash2 className="h-4 w-4" /></button>
            </div>
            <div className="mt-3 font-display text-2xl font-bold">{f.amount}</div>
            {f.unit && <div className="text-xs text-slate-500">{f.unit}</div>}
            {f.notes && <p className="text-sm text-slate-600 mt-2">{f.notes}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
